"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nullCriteriaRefMeasureObs = exports.addIdsToPopulationResult = exports.findObsMsrPopl = exports.isDetailedResult = exports.pruneDetailedResults = void 0;
const __1 = require("..");
const Enums_1 = require("../types/Enums");
const MeasureBundleHelpers_1 = require("./MeasureBundleHelpers");
function pruneDetailedResults(executionResults) {
    const prunedExecutionResults = [];
    executionResults.forEach(er => {
        if (er.evaluatedResource) {
            delete er.evaluatedResource;
        }
        if (er.detailedResults) {
            const prunedDetailedResults = er.detailedResults.map(dr => {
                return Object.assign(Object.assign(Object.assign(Object.assign({ groupId: dr.groupId }, (dr.componentCanonical && { componentCanonical: dr.componentCanonical })), (dr.populationResults && { populationResults: dr.populationResults })), (dr.episodeResults && { episodeResults: dr.episodeResults })), (dr.stratifierResults && { stratifierResults: dr.stratifierResults }));
            });
            const newEr = Object.assign(Object.assign({}, er), { detailedResults: prunedDetailedResults });
            prunedExecutionResults.push(newEr);
        }
        else {
            // If detailed results don't exist, there's nothing to prune.
            // we can pass through a casted version of `er`
            prunedExecutionResults.push(er);
        }
    });
    return prunedExecutionResults;
}
exports.pruneDetailedResults = pruneDetailedResults;
function isDetailedResult(result) {
    const candidate = result;
    return (candidate.html != null ||
        candidate.populationRelevance != null ||
        candidate.clauseResults != null ||
        candidate.statementResults != null);
}
exports.isDetailedResult = isDetailedResult;
function findObsMsrPopl(group, obsrvPop) {
    var _a, _b, _c, _d;
    let msrPop = (_a = group.population) === null || _a === void 0 ? void 0 : _a.find(population => __1.MeasureBundleHelpers.codeableConceptToPopulationType(population.code) === Enums_1.PopulationType.MSRPOPL);
    // Measure populations may also use 'http://hl7.org/fhir/us/cqfmeasures/StructureDefinition/cqfm-criteriaReference' extension to reference another population within the same group
    // In this case, we can identify the population that is being observed by looking through the entire group for a population with an ID that matches the valueString of this extension
    if (!msrPop) {
        const criteriaRefId = (0, MeasureBundleHelpers_1.getCriteriaReferenceIdFromPopulation)(obsrvPop);
        if (criteriaRefId != null) {
            msrPop = (_b = group.population) === null || _b === void 0 ? void 0 : _b.find(p => p.id === criteriaRefId);
        }
        else {
            // If not using an extension to reference the relevant populations, fallback to assumption approach of the string literals
            // for "Denominator Observations" or "Numerator Observations" that was used in some other ratio measures
            if (obsrvPop.criteria.expression === 'Denominator Observations') {
                // denominator assumed population
                msrPop = (_c = group.population) === null || _c === void 0 ? void 0 : _c.find(population => __1.MeasureBundleHelpers.codeableConceptToPopulationType(population.code) === Enums_1.PopulationType.DENOM);
            }
            else if (obsrvPop.criteria.expression === 'Numerator Observations') {
                // numerator assumed population
                msrPop = (_d = group.population) === null || _d === void 0 ? void 0 : _d.find(population => __1.MeasureBundleHelpers.codeableConceptToPopulationType(population.code) === Enums_1.PopulationType.NUMER);
            }
        }
    }
    return msrPop;
}
exports.findObsMsrPopl = findObsMsrPopl;
function addIdsToPopulationResult(populationResult, population) {
    if (population.id) {
        populationResult.populationId = population.id;
    }
    if (population.extension) {
        const criteriaRefId = __1.MeasureBundleHelpers.getCriteriaReferenceIdFromPopulation(population);
        if (criteriaRefId) {
            populationResult.criteriaReferenceId = criteriaRefId;
        }
    }
}
exports.addIdsToPopulationResult = addIdsToPopulationResult;
/**
 * Finds the measure observation that references the desired population in its criteria reference. If one exists,
 *  sets the result to false and the observations to null
 *
 *  NOTE: the usage of criteriaReference to identify a measure observation only really applies for Ratio measures
 *  where observations can be done on both the numerator and the denominator. For logic relating to CV measures that have a measure-population,
 *  the nulling of irrelevant observations happens already via `handlePopulationValues`
 */
function nullCriteriaRefMeasureObs(group, populationResults, desiredPopulationType) {
    const measureObservationResults = populationResults.filter(result => result.populationType === Enums_1.PopulationType.OBSERV);
    // We need to do a lookup based on the criteriaReference extension, and only null out that relevant observation
    const relevantObservationResult = (0, MeasureBundleHelpers_1.getObservationResultForPopulation)(group, measureObservationResults, desiredPopulationType);
    if (relevantObservationResult) {
        relevantObservationResult.result = false;
        relevantObservationResult.observations = null;
    }
}
exports.nullCriteriaRefMeasureObs = nullCriteriaRefMeasureObs;
//# sourceMappingURL=DetailedResultsHelpers.js.map